module.exports = __webpack_public_path__ + "static/media/nhiv.ca80b93e.svg";